export default "__VITE_ASSET__22b77cb2__"